namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogImportCertifikacniAutorita extends GContentBase {
        private formEl: JQuery<HTMLElement>;

        private srv() {
            return this.createServiceContent("Gordic.Adm.WebControls.DialogImportCertifikacniAutorita")
        }

        importCertificate() {
            if (this.formEl.gform("isValid")) {
                var file: Gordic.General.ApplicationInterface.GFileInfoDto[] = this.element.findFields("cerFile").gfield("getValue");
                if (file.length > 0) {
                    this.beginOperation();
                    this.srv().call("LoadFile", { guid: file[0].guid }).done((content) => {
                        var ext = file[0].filename?.split(".").pop()?.toUpperCase();
                        this.isl.CertifikacniAutorita.importCerFile({ data: { typ_souboru_cert: ext, file_content: content } }).get().done((certAut) => {
                            this.successNot();
                            this.close(true);
                        }).fail(() => {
                            this.failNot();
                        })
                    }).fail(() => {
                        this.failNot();
                    }).always(() => {
                        this.endOperation();
                    })
                }
            }
        }

        onClose() {
            var file = this.element.findFields("cerFile").gfield("getValue")
            if (file.length > 0)
                this.srv().fire("ClearFile", { guid: file[0].guid })
        }

        onContentReady() {
            this.init();
        }

        private init() {
            this.createForm()
        }

        private createForm() {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:32000154").addField("gfilefield", {
                    name: "cerFile",
                    acceptExtension: ".cer",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    fileRemoved: (ev, fileInfo) => {
                        if (fileInfo)
                            this.srv().call("ClearFile", { guid: fileInfo.fileInfo.guid })
                    }
                })

            this.formEl = $("<div>").appendTo(this.element).gform("createFrom", form);
        }

        private failNot() {
            $.content($("#main")).notification("add", {
                state: "error",
                shortTemplate: "<b>jres:29809454</b><br /><span>jres:33000051</span>", //RC 33000051 : Chyba při importu certifikátu.
                content: {},
                icon: "fa-exclamation-circle"
            }, true)
        }

        private successNot() {
            $.content($("#main")).notification("add", {
                state: "success",
                shortTemplate: "<b>jres:29809454</b><br /><span>jres:33000052</span>", //RC 33000052 : Import certifikátu dopadl úspěšně.
                content: {},
                icon: "fa-check-circle"
            }, true)
        }
    }
}